import { getCookie } from "../../support/Cookie";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Quiz601, Quiz602 } from "./Quiz1060";

export default function Quiz10() {
  const navigate = useNavigate();
  if (!(Number(getCookie("role")) > 0)) {
    navigate("/login");
  }
  return (
    <>
      <h1>도움 받아 해결하기</h1>
      <Routes>
        <Route path="1" element={<Quiz601 />} />
        <Route path="2" element={<Quiz602 />} />
      </Routes>
    </>
  );
}
